/* reorder-api.live.js — LIVE adapter. Drop-in replacement for the fixture
 * reorder-api.js. Same ReorderAPI surface (6 methods) so reorder-flow.js is
 * unchanged. Swap this in as assets/reorder-api.js when going live on staging.
 *
 * SET SERVICE_URL to the deployed function trigger URL before uploading
 * (gcloud functions describe lookupPets --gen2 --region us-west1 --format='value(url)').
 */
var ReorderAPI = (function () {
  var SERVICE_URL = 'https://pet-lookup-wubvk2slqa-uw.a.run.app'; // deployed function (us-west1)

  // STAGING GUARDRAIL: this adapter lives only on the staging theme. Every write
  // it sends carries _test:true, so the backend forces Review_Status=Needs_Review
  // and prefixes Triage_Reason with "TEST - " — a test submission can never
  // auto-release to fulfillment. Set to false ONLY on the production adapter.
  // 2026-09-18: switched OFF for the live site (Charles). Writes are no longer
  // stamped _test, so they route on the normal hold/release rules.
  var STAGING_TEST = false;
  function tagTest(payload) {
    var p = payload || {};
    if (STAGING_TEST) p._test = true;
    return p;
  }

  // ---- sign-in state (2026-09-19) ----
  // The code check returns a signed session; the pet routes require it. Kept in
  // sessionStorage (this tab only, cleared when the tab closes) so a refresh does not
  // send the customer back to the email step. Memory fallback if storage is blocked.
  var SKEY = 'rrReorderSession', _mem = {};
  function _get(k) { try { var v = window.sessionStorage.getItem(k); return v === null ? _mem[k] : v; } catch (e) { return _mem[k]; } }
  function _set(k, v) { _mem[k] = v; try { if (v == null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (e) {} }
  var _codeTicket = null;

  function post(path, payload, withSession) {
    var body = payload || {};
    if (withSession) { var ss = _get(SKEY); if (ss) body = Object.assign({}, body, { _session: ss }); }
    return fetch(SERVICE_URL + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (!r.ok) {
          var code = (data && data.error) || 'REQUEST_FAILED';
          if (code === 'SESSION_REQUIRED' || code === 'NOT_YOUR_PET') { _set(SKEY, null); code = 'SESSION_EXPIRED'; }
          var e = new Error(code); e.code = code; throw e;
        }
        return data;
      });
    });
  }

  return {
    // magic-link keyed entry — server token resolve not yet built; falls back to
    // cold email flow by signalling an invalid token. TODO: /resolve-token.
    resolveToken: function (t) {
      return Promise.reject({ code: 'TOKEN_INVALID' });
    },
    // email -> issue 6-digit code. _devCode is present only when the service
    // runs with STAGING_ECHO_CODE=true (staging test convenience).
    requestCode: function (email) {
      return post('/request-code', { email: String(email || '').trim() }).then(function (d) {
        _codeTicket = (d && d.ticket) || null;
        if (d && d._devCode) { try { console.info('[staging] reorder code:', d._devCode); } catch (e) {} }
        return { sent: true, _devCode: d && d._devCode };
      });
    },
    // verify code -> pets for routing (empty patients => intake path)
    verifyCode: function (email, code) {
      return post('/verify-code', { email: String(email || '').trim(), code: code, ticket: _codeTicket }).then(function (d) {
        if (d && d.session) _set(SKEY, d.session);
        return { patients: d.patients || [], contactId: d.contactId, contactName: d.contactName };
      });
    },
    // rich context for the confirm screen
    getReorderContext: function (id) {
      return post('/context', { petId: id }, true).then(function (d) {
        if (d && d.error) { throw { code: d.error }; }
        return d;
      });
    },
    submitReorder: function (S) { return post('/reorder', tagTest(S), true); },
    submitCheckIn: function (S) { return post('/checkin', tagTest(S), true); },
    hasSession: function () { return !!_get(SKEY); },
    clearSession: function () { _set(SKEY, null); },
    submitIntake: function (intake) { return post('/intake', tagTest(intake)); },
    // verified-vet typeahead — read-only; returns [{ci,ai,v,c,s}] from the bundled roster
    vetSearch: function (q) { return post('/vet-search', { q: q }).then(function (d) { return (d && d.results) || []; }); },
  };
})();
